import { getConfig } from "../../config/config";
import { decryptEnv } from "../../helpers";
const { APP_BASE_API_URL, APP_OCP_APIM_KEY, APP_USER_ID, APP_PASSWORD } = getConfig();
export const getOiProfileData = async (symbol, exch, exchType) => {
    var _a, _b, _c;
    if (symbol === "BSE BANKEX")
        symbol = "BANKEX";
    const url = `${APP_BASE_API_URL}tradeapi/GetOptionchainList/${symbol}/${exch}/${exchType}`;
    const token = (_c = (_a = localStorage.getItem("JWTToken")) !== null && _a !== void 0 ? _a : (_b = localStorage.getItem("paramJwt")) === null || _b === void 0 ? void 0 : _b.replace(/JwtToken=/g, "")) !== null && _c !== void 0 ? _c : "";
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json, text/plain, */*",
                "Authorization": `Bearer ${token}`,
                "Ocp-Apim-Subscription-Key": decryptEnv(APP_OCP_APIM_KEY),
                "UserID": decryptEnv(APP_USER_ID),
                "Password": decryptEnv(APP_PASSWORD),
                "AppName": "Derivative360",
            }
        });
        if (!response.ok) {
            const errText = await response.text().catch(() => "");
            throw new Error(`API Error ${response.status}: ${errText}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error("Error fetching OI Profile Data:", error);
        throw error;
    }
};
/**
 * Fetches OI option chain data for a specific expiry date using the V3 API.
 * Used when the symbol contains an explicit expiry (e.g. "NSE:NIFTY 12 MAY 2026/66071-D").
 * API endpoint: GetOptionsForSymbolV3/{symbol}/{exch}/{exchType}/{expiryDate}
 */
export const getOiProfileDataV3 = async (symbol, exch, exchType, expiryDate // format: YYYY-MM-DD
) => {
    const url = `${APP_BASE_API_URL}tradeapi/GetOptionsForSymbolV3/${symbol}/${exch}/${exchType}/${expiryDate}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json, text/plain, */*",
                "Authorization": `Bearer ${localStorage.getItem("JWTToken")}`,
                "Ocp-Apim-Subscription-Key": decryptEnv(APP_OCP_APIM_KEY),
                "UserID": decryptEnv(APP_USER_ID),
                "Password": decryptEnv(APP_PASSWORD),
                "AppName": "Derivative360",
            }
        });
        if (!response.ok) {
            const errText = await response.text().catch(() => "");
            throw new Error(`API Error ${response.status}: ${errText}`);
        }
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error("Error fetching OI Profile Data (V3):", error);
        throw error;
    }
};
